// src/components/PromptForm.js
import React, { useState, useEffect } from 'react';
import {
  Container,
  Header,
  FormField,
  Input,
  Select,
  Textarea,
  SpaceBetween,
  Button,
  Box,
} from '@cloudscape-design/components';

function PromptForm({ prompt = null, onSubmit, onCancel }) {
  const [title, setTitle] = useState('');
  const [category, setCategory] = useState(null);
  const [promptContext, setPromptContext] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (prompt) {
      setTitle(prompt.title);
      setCategory({ label: prompt.category, value: prompt.category.toLowerCase() });
      setPromptContext(prompt.promptContext);
    }
  }, [prompt]);

  const validate = () => {
    const newErrors = {};
    if (!title) newErrors.title = 'Title is required';
    if (!category) newErrors.category = 'Category is required';
    if (!promptContext) newErrors.promptContext = 'Prompt context is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      onSubmit({
        id: prompt?.id, // Include if editing existing prompt
        title,
        category: category.label,
        promptContext,
      });
    }
  };

  const promptCategories = [
    { label: 'General', value: 'general' },
    { label: 'Cost Management', value: 'cost management' },
    { label: 'Security', value: 'security' },
    { label: 'Performance', value: 'performance' },
    { label: 'Architecture', value: 'architecture' },
    { label: 'Compliance', value: 'compliance' },
    { label: 'Testing', value: 'testing' },
  ];

  return (
    <Container
      header={
        <Header variant="h2">
          {prompt ? 'Edit Prompt' : 'Add New Prompt'}
        </Header>
      }
    >
      <SpaceBetween size="l">
        <FormField
          label="Title"
          description="Enter a descriptive title for the prompt"
          errorText={errors.title}
        >
          <Input
            value={title}
            onChange={({ detail }) => setTitle(detail.value)}
            placeholder="e.g., GCP Analytics Battlecard"
          />
        </FormField>

        <FormField
          label="Category"
          description="Select the category for this prompt"
          errorText={errors.category}
        >
          <Select
            selectedOption={category}
            onChange={({ detail }) => setCategory(detail.selectedOption)}
            options={promptCategories}
            placeholder="Choose prompt category"
          />
        </FormField>

        <FormField
          label="Prompt Context"
          description="Enter the detailed prompt template"
          errorText={errors.promptContext}
        >
          <Textarea
            value={promptContext}
            onChange={({ detail }) => setPromptContext(detail.value)}
            placeholder="Enter the prompt template..."
            rows={10}
          />
        </FormField>

        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button onClick={onCancel}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmit}
            >
              {prompt ? 'Save Changes' : 'Create Prompt'}
            </Button>
          </SpaceBetween>
        </Box>
      </SpaceBetween>
    </Container>
  );
}

export default PromptForm;